// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rhYw","placeholdersHeader":"styles_placeholdersHeader__BNn8i","editorStyle":"styles_editorStyle__3qgpD","placeholdersBox":"styles_placeholdersBox__29kXn"};